import { eLynxObjectTypeEnum } from "../../common/enums/eLynxObjectType";

export const keys = {
    all: ["attributes"],

    allDeviceAttributes: (groupID: number
    ) => [
        ...keys.all,
        "allDeviceAttributes", {
            groupID            
            }
    ],
    allObjectAttributes: (groupID: number,
        objectType: eLynxObjectTypeEnum,
    ) => [
        ...keys.all,
        "allObjectAttributes", {
            groupID,
            objectType
        }
    ],
    getCustomerAttribute: (
        contextGroupID: number,
        name: string,
        ) => [
            ...keys.all,
            "getCustomerAttribute", {
                contextGroupID,
                name
                }
    ],     
    attributesUsage: (organizationID: number, groupID: number, attributeName?: string) => [
        ...keys.all,
        "attributes-usage", {
            organizationID,
            groupID,
            attributeName
        }
    ],
    attributeSchema: (organizationID: number, groupID: number, id: number) => [
        ...keys.all,
        "attribute-schema", {
            organizationID,
            groupID,
            id
        }
    ],
    attributeSchemas: (organizationID: number, groupID: number) => [
        ...keys.all,
        "attribute-schemas", {
            organizationID,
            groupID
        }
    ],
    objectsAttributeValues: (organizationID: number, groupID: number, attributeName: string) => [
        ...keys.all,
        "objects-attribute-values", {
            organizationID,
            groupID,
            attributeName
        }
    ],


};

